// pages/TransactionsCharts.js
import React from 'react';
import LineChartComponent from '../components/LineChartComponent';
import BarChartComponent from '../components/BarChartComponent';
import PieChartComponent from '../components/PieChartComponent';
import ErrorMessage from '../components/ErrorMessage';
import ValuesDisplay from '../components/ValueDisplay';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import '../App.css';

const TransactionsCharts = ({ chartData, loading, error }) => {
  return (
    <Container className="mt-4">
      {loading && (
        <Row className="justify-content-center">
          <Col xs="auto">
            <Spinner animation="border" role="status" />
            <span className="ms-2">Loading...</span>
          </Col>
        </Row>
      )}
      {error && (
        <Row className="justify-content-center">
          <Col xs="auto">
            <ErrorMessage message={error} />
          </Col>
        </Row>
      )}
      {chartData && (
        <>
          <Row className="mb-4">
            <Col xs={12}>
              <ValuesDisplay chartData={chartData} />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={12}>
              <LineChartComponent data={chartData.lineGraphData} />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={12}>
              <LineChartComponent data={chartData.gateCountLineGraph} />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={6} xs={12}>
              <PieChartComponent data={chartData.pieChartData} />
            </Col>
            <Col md={6} xs={12}>
              <BarChartComponent data={chartData.barGraphData} />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default TransactionsCharts;
